<template>
	<div
		ref="header"
		class="app-header"
		:class="{
			'app-header--display-icon': !displayIcon,
			'app-header--center-icon': iconLocation === 'center'
		}"
	>
		<img
			v-if="displayIcon"
			class="app-header__icon"
			data-cy="header-icon"
			:class="{'app-header__icon--center': iconLocation === 'center'}"
			:src="require('@/assets/Centiva_Dark.svg')"
			alt="Centiva"
			@click="redirectLogin()"
		>
		<div
			class="app-header__translation"
			data-cy="header-translation"
			:class="{'app-header__translation--right': iconLocation === 'center'}"
		>
			<helio-icon
				token="globe"
				weight="light"
			/>&nbsp;
			<a :href="translatePageLink">
				{{ translation['translate-content'] }}
			</a>
		</div>
	</div>
</template>

<script>
import { translationMixin } from '../../mixins';

const DEFAULT_ICON_LOCATION = 'default';
const CENTER_ICON_LOCATION = 'center';

export default {
	name: 'Header',
	mixins: [translationMixin],
	props: {
		displayIcon: {
			type: Boolean,
			required: false,
			default: false,
		},

		iconLocation: {
			type: String,
			required: false,
			default: DEFAULT_ICON_LOCATION,
		},
	},
	computed: {
		translation() {
			return this.currentTranslation.login.header;
		},

		translatePageLink() {
			const path = (this.$i18n.messages[this.oppositeLocale].redirect_names[document.location.pathname.replace(`/${this.$i18n.locale}/`, '')]) || '';
			return `/${this.oppositeLocale}/${path}`;
		},
	},
	created() {
		if (this.iconLocation !== DEFAULT_ICON_LOCATION && this.iconLocation !== CENTER_ICON_LOCATION) {
			throw new Error(`Unrecognized icon location: ${this.iconLocation})`);
		}
	},
	methods: {
		redirectLogin() {
			this.$router.push({ name: `home-${this.$i18n.locale}` });
		},
	},
};
</script>

<style scoped lang="scss" src="./header.scss" />
